import { AxDropdown } from "@axess/limestone";
import Swal from "sweetalert2";
import { AxDatePicker, Cell, Mode, Options } from "../../Components/AxDatepicker/AxDatepicker";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { LoadingSpinnerPositionEnum } from "../../Lib/Enums/LoadingSpinnerPositionEnum";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("ComplexPackageDetails")
export class ComplexPackageDetails implements AxInit {
    private $parent: JQuery<HTMLElement> = $('[data-frontoffice-view="complexpackagesdetails"]');
    private $counterWrapper = this.$parent.find('[data-counter-wrapper]');
    private initData: ICompPackDetailsInitData = {} as ICompPackDetailsInitData;

    private axLoading: AxLoading = new AxLoading();
    private datePicker!: AxDatePicker;
    private datePickerMobile!: AxDatePicker;
    private i18nHelper = new I18nHelper();

    private dateDropdown: AxDropdown = new AxDropdown();
    private dateMobileDropdown: AxDropdown = new AxDropdown();

    private activateDate: moment.Moment | null = null;
    private selectedSoapDate!: string;
    private counterValue: number = 1;

    private selectedBookingDateKey: string = "selectedCompackBookingDate";

    AxInit(init: ICompPackDetailsInitData): void {
        this.initData = init;
        window.addEventListener('pageshow', (e) => {
            if (e.persisted) {
                this.axLoading.HideLoadingIndicator($('.compPack_details_body')?.get(0) as HTMLElement);
            }
        });
        this.dateDropdown.init('.prod_selection__date-selection .ax-dropdown');
        this.dateMobileDropdown.init('.compPack-searchbar__date-selection-mobile .ax-dropdown');

        const selectedCompackBookingDate = localStorage.getItem(this.selectedBookingDateKey);

        // check if this is a redirect after login
        // if yes -> use date from localstorage and proceed to booking options
        if (selectedCompackBookingDate) {
            let selectedDateMoment = moment(selectedCompackBookingDate);
            this.activateDate = selectedDateMoment;
            const formattedDate = selectedDateMoment.format(this.initData.datePattern);
            this.dateDropdown.setValue(formattedDate);
            this.dateMobileDropdown.setValue(formattedDate);

            const selectedSoapDateTemp = this.activateDate.format('YYYY-MM-DD');
            this.selectedSoapDate = selectedSoapDateTemp;

            localStorage.removeItem(this.selectedBookingDateKey);

            this.bookingOptions();
        }

        $('[data-booking-btn]').prop("disabled", true);        

        // if no first valid date was found
        if (this.initData.startDate === '') {
            Swal.fire({
                title: 'Problem occurred',
                text: 'Product not availeable. Please contact the support.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok'
            });
        }

        this.addDatePickerListener();

        $('[data-booking-btn]').on('click', () => this.bookingOptions());

        if (this.initData.hasPrivateLesson) {
            this.addCounterListeners();
        }

        window.addEventListener('mouseup', event => {
            const target = event.target as HTMLInputElement;
            this.closeOpenSelectors(target);
        });
    }

    private addCounterListeners() {
        const availableParticipants = 'data-available-participants';

        const updateCounter = ($counter: JQuery<HTMLElement>, participants: number, max: number) => {
            const $minus = this.$parent.find('[data-counter-minus]');
            const $plus = this.$parent.find('[data-counter-add]');

            $counter.text(participants);
            $minus.prop('disabled', participants <= 1);
            $plus.prop('disabled', participants >= max);
            this.changeCounterText(participants, Number($counter.attr(availableParticipants)));
            this.$parent.trigger('price:update', [participants]);
        }

        this.$parent.on('click', '[data-counter-minus]', (e) => {
            const $counter = $(e.currentTarget).next();
            const max = Number($counter.attr(availableParticipants));
            this.counterValue = Number($counter.text());
            if (Number($counter.attr(availableParticipants)) >= this.counterValue) {
                this.counterValue--;
            }
            updateCounter($counter, this.counterValue, max);
        });

        this.$parent.on('click', '[data-counter-add]', (e) => {
            const $counter = $(e.currentTarget).prev();
            const max = Number($counter.attr(availableParticipants));
            this.counterValue = Number($counter.text());
            if (this.counterValue < Number($counter.attr(availableParticipants))) {
                this.counterValue++;
            }
            updateCounter($counter, this.counterValue, max);
        });

        this.$parent.on('price:update', (_, participants: number = 1, isHtml: boolean = true) => {
            const $priceContainer = this.$parent.find('[data-price-container]');
            const data = {
                tariffSheetId: this.initData.tariffSheetId,
                packageId: this.initData.packageId,
                participants,
                isHtml,
            }

            AxessViewer.loadPartialView('/ComplexPackagesDetails/GetTotalAfterDiscounts', data, (res: { success: boolean, data: string }) => {
                $priceContainer.html(res.data);
            }, {
                silent: true,
            });
        });
    }

    private changeCounterText(selection: number, available: number) {
        const $additionalParticipant = this.$parent.find('[data-additional-participant-text]');
        const $additionalParticipantPrice = this.$parent.find('[data-additional-participan-price]')
        const maxText = $additionalParticipant.attr('data-max') as string;
        const firstText = $additionalParticipant.attr('data-first') as string;
        const nextText = $additionalParticipant.attr('data-next') as string;
        const text = selection == available ? maxText : nextText;
        $additionalParticipant.text(selection == 1 ? firstText : text);
        const data = {
            tariffSheetId: this.initData.tariffSheetId,
            packageId: this.initData.packageId,
            persPosNr: selection + 1,
            isHtml: true,
        }
         AxessViewer.loadPartialView('/ComplexPackagesDetails/GetLessonAfterDiscounts', data, (res: { success: boolean, data: string }) => {
             res.success && $additionalParticipantPrice.html(selection < available ? res.data : '');
        }, {
            silent: true,
        });
    }

    private addDatePickerListener() {
        const endDate = this.initData.endDate != null ? moment(this.initData.endDate, "YYYY-MM-DD") : undefined;
        const startDate = moment(this.initData.startDate, "YYYY-MM-DD");

        $('.prod_selection__date-selection').on('click', (x) => {
            this.initDatePicker(endDate, startDate);
            $('.compPack_details_package_includes_datePickerWrapper').addClass('active');
            $('.prod_selection__date-wrapper').toggleClass('active');
        });

        $('.compPack-searchbar__date-selection-mobile').on('click', (x) => {
            this.initDatePicker(endDate, startDate, DeviceMode.Mobile);

            $('.compPack_searchBar-datePicker-wrapper-mobile').toggleClass('active');
            $('body').addClass('overflow-hidden');
        });

        $('.compPack-datePicker-close-btn').on('click', (x) => {
            $('.compPack_searchBar-datePicker-wrapper-mobile').removeClass('active');
        });
    }

    private initDatePicker(endDate: moment.Moment | undefined, startDate: moment.Moment, mode: DeviceMode = DeviceMode.Desktop) {
        const isMob = mode === DeviceMode.Mobile;
        
        const pickerProp = isMob ? 'datePickerMobile' : 'datePicker';
        if (this[pickerProp]) return;

        const options: Options = { 
            StartOfWeek: this.initData.startOfWeek,
            Lang: this.initData.lang,
            StartDate: startDate,
            EndDate: endDate,
            OnlySelectDates: true,
            Target: isMob ? '#tariff_date_mobile' : '#arrival_date',
            Mode: isMob ? Mode.Endless : Mode.Inline,
            OnChange: (startDate: moment.Moment, endDate: moment.Moment) => this.onChangeDate(startDate, endDate, mode),
        };

        if (isMob) {
            options.DayRange = 2;
            options.LegendTarget = '#tariff_date_mobile__legend';
        }

        this[pickerProp] = new AxDatePicker();
        this[pickerProp].Init(options);

        this[pickerProp].ActivationSubject.subscribe(cell => this.handleDateSelection(cell, mode));
    }

    private closeOpenSelectors(clickedElement: HTMLElement) {
        const locationSelect = $(".compPack_details_package_includes_datePickerWrapper");
        if (!locationSelect.is(clickedElement) && locationSelect.has(clickedElement).length === 0) {
            if ($('.compPack_details_package_includes_datePickerWrapper').hasClass('active')) {
                $('.compPack_details_package_includes_datePickerWrapper').removeClass('active');
            }

            $('body').removeClass('overflow-hidden');
        }
    }

    private async onChangeDate(startDate: moment.Moment, endDate: moment.Moment, mode: DeviceMode = DeviceMode.Desktop) {
        const picker = mode === DeviceMode.Mobile ? this.datePickerMobile : this.datePicker;
        if (!picker) return;
        this.checkAvailability(startDate, endDate);
        picker.Options.AvailableDates = [];
    }

    private bookingOptions() {
        let body = $('.compPack_details_body')?.get(0) as HTMLElement;
        this.axLoading.ShowLoadingIndicatorFixed(body);

        const fullPath = $("#bookingOptionsLinkHidden").val() as string;
        const [path, querystring] = fullPath.split('?');

        const params = new URLSearchParams(querystring);
        params.set('soaPDate', this.selectedSoapDate);
        params.set('participants', this.counterValue.toString());
        params.set('hasDiscounts', this.initData.hasDiscounts.toString());

        window.location.href = `${path}?${params.toString()}`;
    }

    private handleDateSelection(cell: Cell, mode: DeviceMode = DeviceMode.Desktop) {
        const isMob = mode === 'mobile';
        const ui = {
            dropdown: isMob ? this.dateMobileDropdown : this.dateDropdown,
            wrapper:  isMob ? '.compPack_searchBar-datePicker-wrapper-mobile' : '.compPack_details_package_includes_datePickerWrapper',
            btn: `[data-booking-btn="${mode}"]`,
        };

        this.$counterWrapper.empty();

        if (cell) {
            this.activateDate = cell.Date;
            ui.dropdown.setValue(this.activateDate.format(this.initData.datePattern));
            $(ui.wrapper).removeClass('active');

            $(ui.btn).html(this.i18nHelper.GetTranslation(Translations.BookNow));
            
            if (!this.initData.hasPrivateLesson) {
                $(ui.btn).prop("disabled", false);
            }

            const soapDate = this.activateDate.format('YYYY-MM-DD');
            this.getParticipantsCounter(soapDate);
            this.selectedSoapDate = soapDate;
        } else {
            if (!isMob) ui.dropdown.resetSelection(); 
            this.activateDate = null;
        }

        if (isMob) ui.dropdown.jumpToElement($('.compack_details_date_holder_mobile'));
    }

    private checkAvailability(fromDate: moment.Moment, toDate: moment.Moment) {
        const data = {
            arcNr: null,
            soapFromDate: fromDate.format('YYYY-MM-DD'),
            soapToDate: toDate.format('YYYY-MM-DD'),
            projNr: this.initData.projNr,
            tariffSheetId: this.initData.tariffSheetId,
            packageId: this.initData.packageId,
        };

        this.axLoading.ShowLoadingIndicator($('.compPack_details_package_includes_datePickerWrapper')?.get(0) as HTMLElement);
        this.axLoading.ShowLoadingIndicator($('.prod_selection__scrollable')?.get(0) as HTMLElement);

        AxessViewer.ajaxRequest('/api/ComplexPackagesValidDaysApi/GetValidDaysCompPack', data, (resp) => {
            const days = resp?.Days || [];
            days.forEach((day) => {
                if (!day.IsValid || !day.IsStartDay || day.TicketsAvailable < 1) {
                    const momentDate = moment(day.Date);

                    if (this.datePicker) {
                        this.datePicker.BlockDate(momentDate);
                    }

                    if (this.datePickerMobile) {
                        this.datePickerMobile.BlockDate(momentDate);
                    }
                }
            });
            this.axLoading.HideLoadingIndicator($('.compPack_details_package_includes_datePickerWrapper')?.get(0) as HTMLElement);
            this.axLoading.HideLoadingIndicator($('.prod_selection__scrollable')?.get(0) as HTMLElement);
        }, null);
    }

    private getParticipantsCounter(date: string) {
        if (!this.initData.hasPrivateLesson) return;

        this.$counterWrapper.removeClass('d-none');
        this.axLoading.ShowLoadingIndicator(this.$counterWrapper?.get(0) as HTMLElement, true, LoadingSpinnerPositionEnum.Center);

        const data = {
            ticketsTriple: this.initData.ticketsTriple,
            lessonsTriple: this.initData.lessonsTriple,
            rentalAvailableItemCount: this.initData.rentalAvailableItemCount,
            date,
            tariffSheetId: this.initData.tariffSheetId,
            packageId: this.initData.packageId,
        }

        const getParticipants = AxessViewer.loadPartialView('/ComplexPackagesDetails/GetParticipantsCounter', data, (res: { success: boolean, data: string }) => {
            if (res?.success) {
                this.$counterWrapper.html(res.data);

                const $counter = this.$parent.find('[data-available-participants]');
                this.counterValue = Number($counter.attr('data-available-participants')) > 0 ? 1 : 0;
                $('[data-booking-btn]').prop("disabled", this.counterValue === 0);
            } else {
                this.$counterWrapper.addClass('d-none');
            }
        }, {
            silent: true,
        });

        getParticipants.then(() => {
            this.axLoading.HideLoadingIndicator(this.$counterWrapper?.get(0) as HTMLElement);
        });
    }
}

export interface ICompPackDetailsInitData {
    startOfWeek: number;
    lang: string;
    startDate: string;
    endDate?: string;
    postUrl: string;
    datePattern: string;
    datePatternYear: string;
    checkDateLink: string;
    projNr: number;
    packageId: number;
    tariffSheetId: number;
    userLoggedIn: string;
    lessonsTriple: string[];
    ticketsTriple: string[];
    rentalAvailableItemCount: number;
    hasPrivateLesson: boolean;
    hasDiscounts: boolean;
    lessonsDiscounts: LessonDiscounts[];
    totalPrice: number;
    totalPriceLessonNonPrivate: number;
}

interface LessonDiscounts {
    rentalItemNr: number;
    rentalPersTypeNr: number;
    personPositionNr: number;
    discountNr: number;
    discountTariffSheetNr: number;
    discountName: string;
    discountPercentage: number;
    isFreeDefinable: boolean;
}

interface LessonDiscountsForCounter {
    rentalNr: number;
    discounts: LessonDiscountsValues[];
}

interface LessonDiscountsValues {
    position: number;
    price: number;
}

enum DeviceMode {
    Desktop = 'desktop',
    Mobile = 'mobile',
}